import { render, staticRenderFns } from "./MenuSelfService.vue?vue&type=template&id=4a5413a3&scoped=true"
import script from "./MenuSelfService.vue?vue&type=script&lang=js"
export * from "./MenuSelfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5413a3",
  null
  
)

export default component.exports